import { useEffect } from "react";
import { useSelector } from "react-redux";
import { isPartnerMehudet } from "../store/partnerStore";
import { updateTranslationsForPartner } from "../i18n";

const TranslationProvider = ({ children }) => {
  const isMehudet = useSelector(isPartnerMehudet);

  useEffect(() => {
    updateTranslationsForPartner(isMehudet);
  }, [isMehudet]);

  return <>{children}</>;
};

export default TranslationProvider;
